const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const webLinkPattern = /\b(?:https?:\/\/|www\.|[a-z0-9-]+\.(?:com|net|org|io|co|us|biz|info|me|app|dev)(?:\b|\/))/i
const webLinkPatternGlobal = /\b(?:(?:https?:\/\/|www\.)[^\s]+|[a-z0-9-]+(?:\.[a-z0-9-]+)*\.(?:com|net|org|io|co|us|biz|info|me|app|dev)(?:\/[^\s]*)?)/gi

export function trimmed(value: FormDataEntryValue | null) {
  return String(value ?? '').trim()
}

export function normalizePhone(value: string) {
  const trimmedValue = value.trim()
  if (!trimmedValue) return ''

  const digits = trimmedValue.replace(/\D/g, '')
  if (digits.length === 10) return `+1${digits}`
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`
  if (trimmedValue.startsWith('+') && digits.length >= 8 && digits.length <= 15) return `+${digits}`
  return null
}

export function isValidEmail(value: string) {
  return emailPattern.test(value)
}

export function isSafeWebUrl(value: string) {
  if (!value) return true
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && !url.username && !url.password && url.hostname.includes('.')
  } catch {
    return false
  }
}

export function containsWebLink(value: string) {
  return webLinkPattern.test(value)
}

export function countWebLinks(value: string) {
  return value.match(webLinkPatternGlobal)?.length ?? 0
}

export function hasRepetitiveContent(value: string) {
  if (/([a-z0-9])\1{11,}/i.test(value)) return true
  if (/\b([a-z]{3,})\b(?:[\s,.;!?-]+\1\b){4,}/i.test(value)) return true

  const words = value.toLowerCase().match(/[a-z0-9]{2,}/g) ?? []
  return words.length >= 20 && new Set(words).size / words.length < 0.18
}

export function isSuspiciousMessage(value: string) {
  return countWebLinks(value) > 1 || hasRepetitiveContent(value)
}

export function validationMessage(condition: boolean, message: string) {
  return condition ? undefined : message
}
